import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-table-cloneable', 'addRow', 'Lisa rida');
Labels.set('ui-table-cloneable', 'removeRow', 'Eemalda rida');
